module.exports = __webpack_public_path__ + "static/media/add.0cf60242.svg";